import { authHeader } from '@/_helpers';
import {userService} from "@/_services/user.service";
import {API_URL} from "../config/app";

const URL = API_URL

export const creditPacksService = {
  getAll,
  buyCreditPack,
  buySignatures
};

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(URL + "/credit_pack", requestOptions)
    .then(handleResponse)
    .then(response => Promise.resolve(response))
}

function buyCreditPack(creditPackId, paymentMethod) {

  let formData = new FormData()
  formData.append("credit_pack_id", creditPackId);
  formData.append("payment_method", paymentMethod);

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/credit_pack", requestOptions).then(handleResponse);
}

function buySignatures(amount, paymentMethod, cardId) {
  let formData = new FormData()
  formData.append("amount", amount);
  formData.append("payment_method", paymentMethod);
  formData.append("card_id", cardId);

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/credit_pack", requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.refreshToken();
        return Promise.reject("Intentando recuperar la sesión");
      }

      const error = (data && data.errors[0].detail) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
